import React, { useEffect } from 'react';

// Components
import * as S from './Styled';
import Input from '../../Input';
import { useFormik } from 'formik';
import InputMask from 'react-input-mask';
import { withGoogleReCaptcha } from 'react-google-recaptcha-v3';
import Badge from '../../Badge';
import { Button } from '../../Button';
import Spinner from '../../Spinner';

// Utils
import cn from 'classnames';
import i18next from 'i18next';
import * as Yup from 'yup';

// Store
import { useSelector } from 'react-redux';
import Alert from '../../Alert';
import { useTranslation } from 'react-i18next';

const Login = ({ onSignup, onLogin, googleReCaptchaProps, onRestore }) => {
  const { vErrors, isLoading, vMessage } = useSelector(state => state.auth);
  const { t } = useTranslation();

  useEffect(() => {
    if (vErrors) {
      vErrors.map(i => formik.setFieldError(i.field, i.error));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [vErrors]);

  const formik = useFormik({
    initialValues: {
      phone: '',
      password: '',
    },
    validationSchema: Yup.object({
      phone: Yup.string().required(i18next.t('validation.required')),
      password: Yup.string().required(i18next.t('validation.required')),
    }),

    onSubmit: async (values, formik) => {
      await onLogin({
        ...values,
        _recaptcha: await googleReCaptchaProps.executeRecaptcha('login'),
      });
    },
  });
  const { errors, handleSubmit, handleChange, touched, isSubmitting } = formik;

  if (isLoading) {
    return (
      <S.Login>
        <S.SpinnerCase>
          <Spinner size="small" flow="block" />
        </S.SpinnerCase>
      </S.Login>
    );
  }

  return (
    <S.Login>
      <form onSubmit={handleSubmit}>
        <S.Container>
          <S.Title>{t('labels.log_in')}</S.Title>
          {vMessage ? <Alert error>{vMessage}</Alert> : null}
          <S.Row
            className={cn({
              error: errors.phone,
            })}
          >
            <InputMask
              disabled={isLoading}
              mask="380999999999"
              name="phone"
              onChange={handleChange}
              maskPlaceholder={null}
            >
              <Input label={t('labels.phone_number')} autoFocus />
            </InputMask>
            <S.Error>{touched.phone && errors.phone}</S.Error>
          </S.Row>
          <S.Row
            className={cn({
              error: errors.password,
            })}
          >
            <Input
              disabled={isLoading}
              type="password"
              name="password"
              label={t('labels.password')}
              onChange={handleChange}
            />
            <S.Error>{touched.password && errors.password}</S.Error>
          </S.Row>
          <S.Row>
            <Button
              size="middle"
              type="primary"
              style={{ width: 102 }}
              htmlType="submit"
              disabled={isSubmitting || isLoading}
            >
              {t('buttons.log_in')}
            </Button>
            <S.ForgotPassLink onClick={onRestore}>
              {t('labels.forgot_password')}
            </S.ForgotPassLink>
          </S.Row>
        </S.Container>
        <S.Footer>
          <S.BText>
            {t('labels.no_account')}
            <S.SignupLink _onClick={onSignup}>
              {t('labels.sign_up')}
            </S.SignupLink>
            <Badge feature>{t('labels.soon')}</Badge>
          </S.BText>
        </S.Footer>
      </form>
    </S.Login>
  );
};

export default withGoogleReCaptcha(Login);
